import {Web3AuthSignatureGroup} from '#/hooks/use-web3auth-signature-group';
import {ApiBodyWithoutSignature, fetchFromApiRoute, fetchFromApiRouteWithSignature} from '#/utils/fetch-utils';
import {ApiUserProfile, apiUserProfile} from 'shareland-common';

const get = async (
  params: ApiUserProfile['get']['paramsDictionary'] & {skipCache: boolean},
): Promise<ApiUserProfile['get']['resBody']['data']> => {
  const {account, skipCache} = params;

  const res = await fetchFromApiRoute<ApiUserProfile['get']>(apiUserProfile.endpoints.get, {
    paramsDictionary: {account: account!},
    reqBody: null,
    reqQuery: {...(skipCache ? {skipCache: true} : {})},
  });

  return res ?? null;
};

const getPrivate = async (
  params: ApiBodyWithoutSignature<ApiUserProfile['getPrivate']['reqBody']>,
  web3AuthSignatureGroup: Web3AuthSignatureGroup,
): Promise<ApiUserProfile['getPrivate']['resBody']['data']> => {
  const res = await fetchFromApiRouteWithSignature<ApiUserProfile['getPrivate']>(
    apiUserProfile.endpoints.getPrivate,
    {
      paramsDictionary: null,
      reqBody: params,
      reqQuery: {skipCache: true},
    },
    web3AuthSignatureGroup,
  );

  return res ?? null;
};

const upsert = async (
  params: ApiBodyWithoutSignature<ApiUserProfile['upsert']['reqBody']>,
  web3AuthSignatureGroup: Web3AuthSignatureGroup,
): Promise<ApiUserProfile['upsert']['resBody']['data']> => {
  const res = await fetchFromApiRouteWithSignature<ApiUserProfile['upsert']>(
    apiUserProfile.endpoints.upsert,
    {
      paramsDictionary: null,
      reqBody: params,
      reqQuery: {},
    },
    web3AuthSignatureGroup,
    true,
  );

  return res ?? null;
};

const login = async (
  web3AuthSignatureGroup: Web3AuthSignatureGroup,
): Promise<ApiUserProfile['login']['resBody']['data']> => {
  const res = await fetchFromApiRouteWithSignature<ApiUserProfile['login']>(
    apiUserProfile.endpoints.login,
    {
      paramsDictionary: null,
      reqBody: {},
      reqQuery: {},
    },
    web3AuthSignatureGroup,
    true,
  );

  return res ?? null;
};

const setInitialFundingAmount = async (
  params: ApiBodyWithoutSignature<ApiUserProfile['setInitialFundingAmount']['reqBody']>,
  web3AuthSignatureGroup: Web3AuthSignatureGroup,
): Promise<ApiUserProfile['setInitialFundingAmount']['resBody']['data']> => {
  const res = await fetchFromApiRouteWithSignature<ApiUserProfile['setInitialFundingAmount']>(
    apiUserProfile.endpoints.setInitialFundingAmount,
    {
      paramsDictionary: null,
      reqBody: params,
      reqQuery: {},
    },
    web3AuthSignatureGroup,
    true,
  );

  return res ?? null;
};

const setRequestedFundingAmount = async (
  params: ApiBodyWithoutSignature<ApiUserProfile['setRequestedFundingAmount']['reqBody']>,
  web3AuthSignatureGroup: Web3AuthSignatureGroup,
): Promise<ApiUserProfile['setRequestedFundingAmount']['resBody']['data']> => {
  const res = await fetchFromApiRouteWithSignature<ApiUserProfile['setRequestedFundingAmount']>(
    apiUserProfile.endpoints.setRequestedFundingAmount,
    {
      paramsDictionary: null,
      reqBody: params,
      reqQuery: {},
    },
    web3AuthSignatureGroup,
    true,
  );

  return res ?? null;
};

const signedAvatarUrl = async (
  params: ApiBodyWithoutSignature<ApiUserProfile['signedAvatarUrl']['reqBody']>,
  web3AuthSignatureGroup: Web3AuthSignatureGroup,
): Promise<ApiUserProfile['signedAvatarUrl']['resBody']['data']> => {
  const res = await fetchFromApiRouteWithSignature<ApiUserProfile['signedAvatarUrl']>(
    apiUserProfile.endpoints.signedAvatarUrl,
    {
      paramsDictionary: null,
      reqBody: params,
      reqQuery: {},
    },
    web3AuthSignatureGroup,
    true,
  );

  return res ?? null;
};

export const userProfileRequests = {
  get,
  getPrivate,
  upsert,
  login,
  setInitialFundingAmount,
  setRequestedFundingAmount,
  signedAvatarUrl,
};
